module.exports = __webpack_public_path__ + "static/assets/ba53c89227b8be31707e9542076b6d45.svg";